import type { IconDef } from '../types';

export const prescription: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M19 0C20.65 0 22 1.35 22 3V21C22 22.65 20.65 24 19 24H5C3.35 24 2 22.65 2 21V3C2 1.35 3.35 0 5 0H19ZM5.44043 1.7002C4.89043 1.6802 4.42039 2.11016 4.40039 2.66016L3.61035 20.6504C3.59056 21.2002 4.02044 21.6704 4.57031 21.6904L18.5596 22.2998C19.1096 22.3198 19.5796 21.8898 19.5996 21.3398V21.3301L20.3896 3.34961C20.4094 2.79977 19.9796 2.32957 19.4297 2.30957L5.44043 1.7002ZM17 17.5C17.55 17.5 18 17.95 18 18.5C18 19.05 17.55 19.5 17 19.5H7C6.45 19.5 6 19.05 6 18.5C6 17.95 6.45 17.5 7 17.5H17ZM17 13.5C17.55 13.5 18 13.95 18 14.5C18 15.05 17.55 15.5 17 15.5H7C6.45 15.5 6 15.05 6 14.5C6 13.95 6.45 13.5 7 13.5H17ZM12.5 4.5C13.05 4.5 13.5 4.95 13.5 5.5V7H15C15.55 7 16 7.45 16 8C16 8.55 15.55 9 15 9H13.5V10.5C13.5 11.05 13.05 11.5 12.5 11.5C11.95 11.5 11.5 11.05 11.5 10.5V9H10C9.45 9 9 8.55 9 8C9 7.45 9.45 7 10 7H11.5V5.5C11.5 4.95 11.95 4.5 12.5 4.5Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
